import Container from 'react-bootstrap/Container'
import '../App.css';
import React from 'react'



function Bookcase() {
    return (
        <>
        <Container className="hero">
            <div className="hero-text">
                <h1>Your Shelf</h1>
                <h4>All your chosen future reads</h4>
            </div>
        </Container>
        </>   
        )
    }

export default Bookcase